import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Environment } from '../../../environments/environment.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: Environment | null = null;
  private configLoadedSubject = new BehaviorSubject<boolean>(false);

  constructor() {
    this.loadConfig().catch(error => {
      console.error('Error loading configuration:', error);
    });
  }

  async loadConfig(): Promise<void> {
    try {
      // Importar environment dinámicamente
      const envModule = await import('../../../environments/environment');
      this.config = envModule.environment;
      this.configLoadedSubject.next(true);
    } catch (error) {
      console.error('Error loading configuration:', error);
      throw error;
    }
  }

  async waitForConfig(): Promise<void> {
    if (this.configLoadedSubject.value) {
      return;
    }
    return new Promise((resolve) => {
      const subscription = this.configLoadedSubject.subscribe(loaded => {
        if (loaded) {
          subscription.unsubscribe();
          resolve();
        }
      });
    });
  }

  getConfig(): Environment {
    if (!this.config) {
      throw new Error('Configuration not loaded. Please ensure loadConfig() has been called and completed successfully.');
    }
    return this.config;
  }
}
